export { styleSingleton } from './component';
export { stylesheetSingleton } from './singleton';
export { styleHookSingleton } from './hook';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-style-singleton/dist/es2015/index.js
// module id = 109
// module chunks = 0